import NotFoundGif from "../../assets/img/not-found.gif";

export const NotFound = () => {
  return (
    <div className="not-found">
      <img src={NotFoundGif} alt="Página não encontrada"/>
    </div>
  );
}